var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 3.6C15.2 2.27452 16.2745 1.2 17.6 1.2H19.4C19.7314 1.2 20 0.931371 20 0.6C20 0.268629 19.7314 0 19.4 0H17.6C15.6118 0 14 1.61178 14 3.6V14.4C14 16.3882 15.6118 18 17.6 18H19.4C19.7314 18 20 17.7314 20 17.4C20 17.0686 19.7314 16.8 19.4 16.8H17.6C16.2745 16.8 15.2 15.7255 15.2 14.4V3.6ZM4.42574 4.32564C4.66005 4.09133 5.03995 4.09133 5.27426 4.32564C5.50858 4.55996 5.50858 4.93986 5.27426 5.17417L2.04853 8.39991H9.39999C9.73137 8.39991 9.99999 8.66854 9.99999 8.99991C9.99999 9.33128 9.73137 9.59991 9.39999 9.59991H2.04853L5.27426 12.8256C5.50858 13.06 5.50858 13.4399 5.27426 13.6742C5.03995 13.9085 4.66005 13.9085 4.42574 13.6742L0.175736 9.42417C-0.0585787 9.18986 -0.0585787 8.80996 0.175736 8.57564L4.42574 4.32564Z",
    fill: "#70797B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandRight);
export default __webpack_public_path__ + "static/media/expand-right.1b07b0cba74fd88b8040fd6eb347f862.svg";
export { ForwardRef as ReactComponent };